export enum RequestStatus {
    NEVER,
    LOADING,
    SUCCESSFULL,
    ERROR
}